// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__edzGU","col":"styles_col__1nVHu"};